// import {combineReducers} from "redux";
import partners from './PartnersReducer';

// if there are more than one reducer in this component, use combineReducers
/*
const partners = combineReducers({
    partners
})
*/

export default partners;
